import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(log => ({
        value: log.id,
        label: log.description,
        event_id: log.event_id
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setItems(state, items) {
      state.items = items
    },
  },
  actions: {
    async getAll({ commit }, params) {
      try {
        const { data } = await axios.get('/v1/bosch/logs', { params })

        if (!data) {
          return []
        }

        commit('setData', data.data)
        return data
      } catch (error) {
        console.error('Error fetching bosch logs:', error)
        throw error
      }
    },
    async fetchItems({ commit }, params) {
      try {
        const { data } = await axios.get('/v1/bosch/logs', { params })
        commit('setItems', data)
      } catch (error) {
        console.error('Error fetching logs:', error)
      }
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
